/**
 * 삼성월정산 (/adm/scs/cash) — 월·지사별 삼성 오더 정산표 + 오더 상세
 * ($j.Pages.Admin.ScsCash / body data-page-name="ScsCash")
 */
export default class ScsCash {
    initialize() {
        let $table = null;

        $(function () {
            updateTitle();
            loadTable();

            $('#searchBtn').click(function () {
                updateTitle();
                $table.ajax.reload();
            });

            $('#excelBtn').click(function () {
                exportExcel();
            });
        });

        function getYearMonth() {
            var val = $('#ser_month_input').val();
            return { year: val.substring(0, 4), month: val.substring(5, 7) };
        }

        function updateTitle() {
            var ym = getYearMonth();
            var gisa = $('#targisa option:selected').text() || '전체지사';
            if (!$('#targisa').val()) gisa = '전체지사';
            $('#reportTitle').text('삼성 전자 ' + gisa + '_ ' + ym.year + '년' + ym.month + '월 수수료 내역');
        }

        function loadTable() {
            var columns = [
                {data: 'rownum',       title: 'NO',      width: '50px',  className: 'text-center'},
                {data: 'work_time',    title: '일시',     width: '140px', className: 'text-left',
                    render: v => $j.Common.Util.formatDateTime(v)
                },
                {data: 'ordernum',     title: '오더번호', width: '80px', className: 'text-center',
                    render: function (data, type, row) {
                        return '<span class="show-detail scs-num" data-num="' + data + '">' + data + '</span>';
                    }
                },
                {data: 'car_price',    title: '오더금액', width: '90px', className: 'text-right'},
                {data: 'gisa_name',    title: '지사명',   width: '80px', className: 'text-center'},
                {data: 'bal_name',     title: '발주자',   width: '120px', className: 'text-center',
                    render: (v, t, r) => r.bal_mb_no ? $j.F.Admin.Member.Pop.cell(r.bal_mb_no, r.bal_owner) + ` [${r.fee_rate}%]` : (v || '')
                },
                {data: 'bal_fee',      title: '수수료',   width: '80px', className: 'text-right'},
                {data: 'soo_name',     title: '수주자',   width: '120px', className: 'text-center',
                    render: (v, t, r) => r.soo_mb_no ? $j.F.Admin.Member.Pop.cell(r.soo_mb_no, r.soo_owner) + ` [${r.fee_rate}%]` : (v || '')
                },
                {data: 'soo_fee',      title: '수수료',   width: '80px', className: 'text-right'},
                {data: 'move_type',    title: '사유',     width: '60px', className: 'text-center'},
                {data: 'gisa_deposit', title: '지사입금액', width: '90px', className: 'text-right'},
                {data: 'memo',         title: '메모',     width: 'auto'}
            ];

            $table = new DataTable('#scs-cash-table', {
                autoWidth: false,
                columns: columns,
                scrollY: 'calc(100vh / var(--adm-zoom, 1) - 340px)',
                scrollCollapse: true,
                scrollX: true,
                headerCallback: function (thead) {
                    $(thead).find('th').css({'text-align': 'center', 'font-weight': 'bold', 'font-size': '14px'});
                },
                rowCallback: function (row, data) {
                    if (data.is_error == 1) {
                        $(row).addClass('error-row');
                    }
                },
                ajax: {
                    url: '/adm/ajax/scs/cash/list',
                    type: 'post',
                    data: function (d) {
                        var ym = getYearMonth();
                        d.ser_year  = ym.year;
                        d.ser_month = parseInt(ym.month, 10);
                        d.targisa   = $('#targisa').val();
                    },
                    dataSrc: function (json) {
                        // 합계 업데이트
                        if (json.totals) {
                            $('#tot-orderP').text(json.totals.tot_orderP);
                            $('#tot-eapee').text(json.totals.tot_eapee);
                            $('#tot-pee').text(json.totals.tot_pee);
                            $('#tot-price').text(json.totals.tot_price);
                            $('#tot-sum').html('발주자+지사: <span class="tot-sum">' + json.totals.tot_sum + '</span>');
                        }
                        return json.data;
                    }
                },
                language: {
                    emptyTable:     "데이터가 없습니다.",
                    info:           "총 _TOTAL_건",
                    infoEmpty:      "",
                    infoFiltered:   "",
                    loadingRecords: "로딩 중...",
                    zeroRecords:    "일치하는 결과가 없습니다.",
                    paginate: {
                        previous: "<i class='fa fa-chevron-left'></i>",
                        next:     "<i class='fa fa-chevron-right'></i>"
                    }
                },
                processing: true,
                serverSide: true,
                ordering: false,
                pageLength: 500,
                lengthChange: false,
                searching: false,
                paging: false
            });

            // 오더 상세
            $('#scs-cash-table').on('click', '.show-detail', function () {
                var num = $(this).data('num');
                showDetail(num);
            });
        }

        function showDetail(num) {
            $.post('/adm/ajax/scs/cash/detail', {num: num}, function(r) {
                if (!r.result) return;
                var html = `<table class="detailtablein">
                    <tr height=30>
                        <th class="scs-w50">작업일시</th>
                        <td align="left">${r.work_date} ${r.work_time} ${r.work_hour_str}</td>
                        <td colspan="2" align="left"><font class="scs-range">${r.car_range_str} [${r.work_content}]</font></td>
                    </tr><tr>
                        <th>장비대금</th>
                        <td align="left">${r.car_price} [${r.pay_status}]</td>
                        <th>${r.cmm} [${r.option_str}]</th>
                        <td align="center">${r.car_type}[${r.order_type_str}]</td>
                    </tr><tr>
                        <th>현장위치</th>
                        <td colspan="2" align="center">${r.site_address}</td>
                        <td align="center">${String(r.num).padStart(6,'0')}</td>
                    </tr><tr>
                        <th>발주자정보</th>
                        <td align="center">${r.bal_name}</td>
                        <th>${r.bal_num}</th>
                        <td>${r.bal_phone}</td>
                    </tr><tr>
                        <th>수주자정보</th>
                        <td align="center">${r.soo_name}</td>
                        <th>${r.soo_num}</th>
                        <td>${r.soo_phone}</td>
                    </tr>
                </table>`;
                $j.Ui.JBModal.html('jb-modal-scs-detail', html, '오더 상세 #' + String(r.num).padStart(6,'0'), {width: '600px'});
            });
        }

        function exportExcel() {
            var $tbl = $('#scs-cash-table');
            var ym = getYearMonth();
            var y = ym.year;
            var m = ym.month;
            var gisa = $('#targisa option:selected').text() || '전체지사';
            if (!$('#targisa').val()) gisa = '전체지사';
            var fname = '삼성 ' + gisa + '_ ' + y + '년' + m + '월.xls';

            var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
            // 헤더
            $tbl.find('thead th').each(function () {
                tab_text += "<th>" + $(this).text() + "</th>";
            });
            tab_text += "</tr>";

            // 데이터
            $tbl.find('tbody tr').each(function () {
                tab_text += "<tr>";
                $(this).find('td').each(function () {
                    tab_text += "<td>" + $(this).text() + "</td>";
                });
                tab_text += "</tr>";
            });

            // 합계
            tab_text += "<tr bgcolor='#C1C1C1'>";
            $tbl.find('tfoot td').each(function () {
                tab_text += "<td><b>" + $(this).text() + "</b></td>";
            });
            tab_text += "</tr></table>";

            var a = document.createElement('a');
            a.href = 'data:application/vnd.ms-excel,' + encodeURIComponent(tab_text);
            a.download = fname;
            a.click();
        }
    }
}
